import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { usePricing } from '../contexts/PricingContext';
import { ContactFormPopup } from './ContactFormPopup';
export function HeroVariant31() {
  const {
    language
  } = useLanguage();
  const {
    price
  } = usePricing();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const content = {
    ru: {
      title: 'Сделаем сайт для вас бесплатно.',
      badge: `Обслуживание — ${price}/мес.`,
      sub: `Мы делаем сайт за свой счёт. Вы смотрите, просите правки, утверждаете. Когда всё нравится — платите ${price} в месяц за хостинг и поддержку. Не понравится — просто уходите. Без оплаты.`,
      cta: 'Начать проект'
    },
    ua: {
      title: 'Зробимо сайт для вас безкоштовно.',
      badge: `Обслуговування — ${price}/міс.`,
      sub: `Ми робимо сайт за свій рахунок. Ви дивитеся, просите правки, затверджуєте. Коли все подобається — платите ${price} на місяць за хостинг та підтримку. Не сподобається — просто йдете. Без оплати.`,
      cta: 'Почати проєкт'
    },
    en: {
      title: 'We build your website for free.',
      badge: `Maintenance — ${price}/mo.`,
      sub: `We build the site at our expense. You review, request edits, and approve. When you love it, you pay ${price}/month for hosting and support. Don't like it? Just walk away. No charge.`,
      cta: 'Start project'
    }
  }[language] || content.ru;
  return <>
      <section className="relative min-h-screen w-full overflow-hidden pt-32 pb-20 flex items-center" style={{
      backgroundColor: 'var(--bg-primary)'
    }} data-id="element-610">
        <div className="relative z-10 mx-auto flex w-full max-w-7xl flex-col lg:flex-row items-center justify-between gap-12 px-4" data-id="element-611">
          {/* Left Column - Badge Highlight */}
          <div className="w-full lg:w-1/2 text-left flex flex-col items-start" data-id="element-612">
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} className="mb-6 text-5xl lg:text-6xl font-black leading-[1.1] tracking-tight text-gray-900" data-id="element-613">
              {content.title}
            </motion.h1>

            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            delay: 0.1
          }} className="mb-8 inline-flex items-center px-6 py-3 rounded-2xl bg-blue-50 border border-blue-100" data-id="element-614">
              <span className="text-2xl font-bold text-blue-700" data-id="element-615">
                {content.badge}
              </span>
            </motion.div>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2
          }} className="text-lg md:text-xl mb-10 text-gray-600 font-medium max-w-lg leading-relaxed border-l-4 border-gray-200 pl-6" data-id="element-616">
              {content.sub}
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.3
          }} data-id="element-617">
              <button onClick={() => setIsPopupOpen(true)} className="group flex items-center justify-center gap-2 rounded-full px-10 py-4 font-bold text-lg transition-all hover:scale-105 bg-gray-900 text-white hover:bg-gray-800" data-id="element-618">
                {content.cta}
                <ArrowRightIcon className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-619" />
              </button>
            </motion.div>
          </div>

          {/* Right Column - Clean Video */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-1/2 relative mt-12 lg:mt-0" data-id="element-620">
            <div className="relative w-full max-w-2xl mx-auto rounded-3xl overflow-hidden shadow-2xl border border-gray-100" data-id="element-621">
              <video src="https://cdn.magicpatterns.com/uploads/vrXe21wkVqS62d5BzpZ9eJ/original-2de319f4767c5a0d4acf4f107b938504.mp4" autoPlay loop muted playsInline className="w-full h-auto" data-id="element-622" />
            </div>
          </motion.div>
        </div>
      </section>
      <ContactFormPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} data-id="element-623" />
    </>;
}